// extracted by mini-css-extract-plugin
module.exports = {"image":"style_image__0HkGT","dialogOverlay":"style_dialogOverlay__WG8Hm","dialogContent":"style_dialogContent__N_k_r","closeIconBttnWrapper":"style_closeIconBttnWrapper__nrDa5"};